import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { AppErrorBoundary } from '@/app/errors/AppErrorBoundary';
import { clearAppQueryCache } from '@/app/providers/queryClient';
import { AppRouter } from '@/app/router/AppRouter';
import { editorStore } from '@/app/store/store';
import { fetchCurrentUser } from '@/features/auth/api/authApi';
import { AuthDialog } from '@/features/auth/ui/AuthDialog';
import { SetPasswordDialog } from '@/features/auth/ui/SetPasswordDialog';
import { UploadProgressTray } from '@/features/upload-asset/ui/UploadProgressTray';
import { clearStoredAuthToken, readStoredAuthToken } from '@/entities/session/model/authStorage';
import { currentUserResolved, sessionExpired } from '@/entities/session/model/sessionSlice';
import { ApiError } from '@/shared/api/errors';
import { configureAuthTokenReader, configureUnauthorizedHandler } from '@/shared/api/httpClient';
/** 安装请求层认证策略：令牌从本地存储读取，401 统一清理会话、查询缓存并弹出登录窗。 */
function installAuthSession() {
    configureAuthTokenReader(readStoredAuthToken);
    configureUnauthorizedHandler(() => {
        clearStoredAuthToken();
        // 先切换会话状态让登录态查询停用，再清空查询缓存，
        // 避免挂载中的查询在缓存清空后立刻重新发起注定失败的请求。
        editorStore.dispatch(sessionExpired());
        clearAppQueryCache();
    });
}
/** 应用启动时执行一次会话恢复，依据 /user/current 结果同步会话状态。 */
async function restoreSession() {
    if (!readStoredAuthToken()) {
        editorStore.dispatch(currentUserResolved(null));
        return;
    }
    try {
        const user = await fetchCurrentUser();
        editorStore.dispatch(currentUserResolved(user));
    }
    catch (error) {
        if (error instanceof ApiError && error.status === 401)
            clearStoredAuthToken();
        editorStore.dispatch(currentUserResolved(null));
    }
}
installAuthSession();
/** 渲染应用错误边界、路由装配与全局认证弹窗，不承载具体业务页面逻辑。 */
export function App() {
    useEffect(() => {
        void restoreSession();
    }, []);
    return (_jsxs(AppErrorBoundary, { children: [_jsx(AppRouter, {}), _jsx(AuthDialog, {}), _jsx(SetPasswordDialog, {}), _jsx(UploadProgressTray, {})] }));
}
